import { useState, useEffect } from 'react';

export function ScrollToTopButton() {
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  
  // 스크롤 이벤트 핸들러
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowScrollToTop(scrollPosition > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!showScrollToTop) return null;

  return (
    <button
      onClick={handleScrollToTop}
      style={{
        position: 'fixed',
        bottom: '90px',
        right: '16px',
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        backgroundColor: '#FFFFFF',
        border: 'none',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 1000,
        opacity: showScrollToTop ? 1 : 0,
        transform: showScrollToTop ? 'scale(1)' : 'scale(0.8)',
        transition: 'all 0.3s ease',
      }}
      aria-label="맨 위로 가기"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 14L12 9L17 14"
          stroke="#222222"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}